<template>
    <div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <h5 class="font-weight-bold">Diagnosis</h5>
                <b-row>
                    <b-col md="6">
                        <b-row>
                            <b-col md="12">
                                <div>
                                    <h5 class="font-weight-bold">Primer</h5>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <template v-if="dataRM.kode_diagnosa_primary">
                                <template
                                    v-if="dataRM.kode_diagnosa_primary.id == '34335' || dataRM.kode_diagnosa_primary.kode == 'IZDOTHER'">
                                    <b-col md="12">
                                        <p v-html="dataRM.kode_diagnosa_primary.description"></p>
                                    </b-col>
                                </template>
                                <template v-else>
                                    <b-col md="12" class="font-weight-bold">
                                        {{ `${dataRM.kode_diagnosa_primary.kode} - ${dataRM.kode_diagnosa_primary.description}` }}
                                    </b-col>
                                </template>
                            </template>
                            <template v-else>
                                <b-col md="12">-</b-col>
                            </template>
                        </b-row>
                    </b-col>
                    <b-col md="6">
                        <b-row>
                            <b-col md="12">
                                <div>
                                    <h5 class="font-weight-bold">Sekunder</h5>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <template v-if="dataRM.kode_diagnosa.length > 0">
                                <b-col md="12">
                                    <b-row v-for="(items, index) in dataRM.kode_diagnosa" :key="index">
                                        <b-col md="12" class="font-weight-bold mb-2">
                                            {{ `${items.kode} - ${items.description}` }}
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </template>
                            <template v-else>
                                <b-col md="12">-</b-col>
                            </template>
                        </b-row>
                    </b-col>
                </b-row>
                <b-row class="mt-2">
                    <b-col md="12">
                        <div class="font-weight-bold">Catatan</div>
                        <div v-html="this.dataRM.diagnosa.notes || '-'"></div>
                        <template v-if="dataRM.diagnosa.draw_path !== null">
                            <img :src="dataRM.diagnosa.draw_path" class="img-fluid" alt="img" />
                        </template>
                    </b-col>
                </b-row>
            </div>
        </div>
        <div class="card card-box mb-3">
            <div class="card-body p-4">
                <h5 class="font-weight-bold">Tata Laksana</h5>
                <b-row class="mt-3">
                    <b-col md="6" lg="6" v-show="kategoriPasien == 2">
                        <h6 class="font-weight-bold">Ditanggung BPJS</h6>
                        <h6 class="mt-3 font-weight-bold">Tindakan <span class="ml-2"
                                v-if="tlPembayaranBPJSTindakan.length == 0">-</span></h6>
                        <template v-if="tlPembayaranBPJSTindakan.length > 0">
                            <table class="table table-borderless">
                                <tbody>
                                    <tr v-for="tl in tlPembayaranBPJSTindakan" :key="tl.id + 'z'">
                                        <td class="p-0" style="width: 50%;">{{ tl.nama_layanan }}</td>
                                        <td style="width: 5%;">{{ tl.quantity }}</td>
                                        <td>{{ tl.keterangan }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                        <h6 class="mt-3 font-weight-bold">Obat <span class="ml-2"
                                v-if="tlPembayaranBPJSObat.length == 0">-</span></h6>
                        <table class="table table-borderless">
                            <tbody>
                                <tr v-for="(item1, index1) in tlPembayaranBPJSObat" :key="index1 + 'y'">
                                    <td class="p-0" style="width: 50%;">{{ item1.nama_layanan }}</td>
                                    <td style="width: 5%;">{{ item1.quantity }}</td>
                                    <td>{{ item1.satuan || '-' }}</td>
                                    <td>
                                        {{ item1.keterangan }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>
                    <b-col md="6" lg="6">
                        <h6 class="font-weight-bold" v-show="kategoriPasien == 2">Tidak Ditanggung BPJS</h6>
                        <h6 class="mt-3 font-weight-bold">
                            Tindakan
                            <span class="ml-2" v-if="tlPembayaranTindakan.length == 0">-</span>
                        </h6>
                        
                        <template v-if="tlPembayaranTindakan.length > 0">
                            <table class="table table-borderless">
                                <tbody>
                                    <tr v-for="tl in tlPembayaranTindakan" :key="tl.id + Math.floor(Math.random() * 1000)">
                                        <td class="p-0" style="width: 50%;">{{ tl.nama_layanan }}</td>
                                        <td style="width: 5%;">{{ tl.quantity }}</td>
                                        <td>{{ tl.keterangan }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                        <h6 class="mt-3 font-weight-bold">Obat & BHP <span class="ml-2"
                                v-if="tlPembayaranObat.length == 0">-</span></h6>
                        <table class="table table-borderless">
                            <tbody>
                                <tr v-for="(item1, index1) in tlPembayaranObat" :key="(index1 + 'a')">
                                    <td class="p-0">{{ item1.nama_layanan }}</td>
                                    <td>{{ item1.quantity }}</td>
                                    <td>{{ item1.satuan ? item1.satuan.name : '-' }}</td>
                                    <td>
                                        {{ (item1.aturan_pakai ? item1.aturan_pakai : '') + (item1.aturan_pakai &&
                                            item1.keterangan ? ', ' + item1.keterangan : '') }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>

                </b-row>
                <b-row v-if="kategoriPasien == 2">
                    <b-col md="12" lg="12">
                        <h6 class="mt-3 font-weight-bold">Terapi Obat</h6>
                        <p>
                            {{ dataRM.bpjs_health_data && checkValueData(dataRM.bpjs_health_data.terapi_obat)  ? dataRM.bpjs_health_data.terapi_obat : '-' }}
                        </p>
                    </b-col>
                </b-row>
                <b-row v-if="kategoriPasien == 2">
                    <b-col md="12" lg="12">
                        <h6 class="mt-3 font-weight-bold">Terapi Non Obat</h6>
                        <p>
                            {{ dataRM.bpjs_health_data && checkValueData(dataRM.bpjs_health_data.terapi_non_obat)  ? dataRM.bpjs_health_data.terapi_non_obat : '-' }}
                        </p>
                    </b-col>
                </b-row>
                <b-row v-if="kategoriPasien == 2">
                    <b-col md="12" lg="12">
                        <h6 class="mt-3 font-weight-bold">BMHP</h6>
                        <p>
                            {{ dataRM.bpjs_health_data && checkValueData(dataRM.bpjs_health_data.bmhp) ? dataRM.bpjs_health_data.bmhp : '-' }}
                        </p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" lg="12">
                        <h6 class="mt-3 font-weight-bold">Tindakan, Terapi dan Saran</h6>
                        <div v-html="this.dataRM.tatalaksana.notes || '-'"></div>
                        <template v-if="dataRM.tatalaksana.draw_path !== null">
                            <img :src="dataRM.tatalaksana.draw_path" class="img-fluid" alt="img" />
                        </template>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Poliklinik",
    props: ["dataRM"],
    data() {
        return {
            tlPembayaranTindakan: [],
            tlPembayaranObat: [],
            tlPembayaranBPJSTindakan: [],
            tlPembayaranBPJSObat: [],
            kodediagnosa: [],
            kategoriPasien: null
        }
    },
    mounted() {
        this.buildData();
    },
    watch: {
        dataRM(val) {
            this.buildData()
        }
    },
    methods: {
        buildData() {
            this.tlPembayaranBPJSTindakan = [];
            this.tlPembayaranBPJSObat = [];
            this.tlPembayaranTindakan = [];
            this.tlPembayaranObat = [];
            let resDig = [];
            this.kategoriPasien = this.dataRM.transklinik.kategori_id
            const pembayaran = this.dataRM.transklinik.pembayaran[0];
            if (pembayaran) {
                if (this.dataRM.transklinik.kategori_id == 2) {
                    pembayaran.detail.forEach((item) => {
                        if (item.from_bpjs == 1) {
                            if (item.bpjs_sk_type == 0) {
                                this.tlPembayaranBPJSTindakan.push(item)
                            } else {
                                this.tlPembayaranBPJSObat.push(item)
                            }
                        }
                        if (item.from_bpjs == 0) {
                            if (item.layanan) {
                                if (item.layanan.kategori_id == 4) {
                                    this.tlPembayaranTindakan.push(item);
                                } else if (item.layanan.kategori_id == 2 || item.layanan.kategori_id == 3) {
                                    this.tlPembayaranObat.push(item);
                                }
                            }
                        }
                    });
                    this.kodediagnosa = this.dataRM.kode_diagnosa;
                } else {
                    pembayaran.detail.forEach((item) => {
                        if (item.layanan) {
                            if (item.layanan.kategori_id == 4) {
                                this.tlPembayaranTindakan.push(item);
                            } else if (item.layanan.kategori_id == 2 || item.layanan.kategori_id == 3) {
                                this.tlPembayaranObat.push(item);
                            }
                        } else {
                            if (item.kode_layanan == 'OUTSIDE_SOURCE') {
                                resDig.push(item);
                            }
                        }
                    });

                    if (resDig.length > 0) {
                        resDig.forEach((item) => {
                            this.tlPembayaranObat.push(item)
                        })
                    }
                }
            }

        },
    }
}
</script>

<style>
.mb-header {
    margin-bottom: -15px;
}
</style>